// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".big[data-v-2c6d7cf9]{font-size:14px;font-weight:500;height:27px;line-height:17px;padding:4px 10px;white-space:nowrap}.big[data-v-2c6d7cf9],.small[data-v-2c6d7cf9]{border-radius:20px}.small[data-v-2c6d7cf9]{font-size:12px;line-height:16px;padding:3px 6px}.error[data-v-2c6d7cf9]{background:#f8f9fa;border:1px solid #ffe0de}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
